import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import WarehouseDetail from "./WarehouseDetail";
import WarehouseStock from './WarehouseStock';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';

// Actions
import {changeWarehouseStatus, getWarehouse, updateWarehouse, deleteWarehouse, cleanWarehouses} from "../../../actions/warehouses";

class WarehouseTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            mode: 'view',
            canSubmit: false,
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        const { warehouseId } = this.props.match.params;

        this.props.getWarehouse(warehouseId);
    }
    componentWillUnmount() {
        this.props.cleanWarehouses();
    }

    // Tab functions
    getSelectedIndex() {
        const {warehouseId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/almacenes/' + warehouseId + '/detalle':
                return 0;
            case '/almacenes/' + warehouseId + '/stock':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {warehouseId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/almacenes/' + warehouseId + '/detalle';
                break;
            case 1:
                route = '/almacenes/' + warehouseId + '/stock';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // WarehouseDetail functions
    handleEditClick = () => {
        this.setState({
            mode: 'edit'
        });
    };
    handleCancelClick = () => {
        this.child.setWarehouseState();
        this.setState({
            mode: 'view',
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateWarehouse();
        this.setState({
            mode: 'view',
            canSubmit: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, mode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar almacén',
                        body: (
                            <DeleteDialog
                                text={ this.props.warehouse.get('warehouse_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteWarehouse(this.props.warehouse.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/almacenes');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/almacenes">Almacenes</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{`[${this.props.warehouse.get('warehouse_code') || ''}] ${this.props.warehouse.get('name') || ''}`}</strong>
                            </li>
                        </ol>
                    </div>
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {mode === 'view'
                                    ? <div className="title-action">
                                        { this.props.warehouse.get('can_delete')
                                            ? <button className="btn btn-danger" onClick={ () => this.openModal('deleteDialog') }>Borrar</button>
                                            : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={ this.handleSaveClick }
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Stock</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <div className="panel-body">
                                                { this.props.warehouse.get('_id')
                                                    ? <WarehouseDetail
                                                        onRef={ref => (this.child = ref)}
                                                        mode={mode}
                                                        updateWarehouse={ this.props.updateWarehouse }
                                                        changeWarehouseStatus={this.props.changeWarehouseStatus}
                                                        warehouse={this.props.warehouse}
                                                        canSubmit={this.canSubmit}
                                                    />
                                                    : null
                                                }
                                            </div>
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.warehouse.get('_id')
                                                ? <WarehouseStock
                                                    warehouse={this.props.warehouse}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const warehouseReducer = state.warehouses;

    // Warehouse
    let warehouse = warehouseReducer.get('payload') || Map({});

    if (!(warehouse instanceof Map)) {
        warehouse = Map({});
    }

    return {
        warehouse
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWarehouse: (warehouseId) => dispatch(getWarehouse(warehouseId)),
        updateWarehouse: (warehouseId, warehouse) => dispatch(updateWarehouse(warehouseId, warehouse)),
        changeWarehouseStatus: (warehouseId, status) => dispatch(changeWarehouseStatus(warehouseId, status)),
        deleteWarehouse: warehouseId => dispatch(deleteWarehouse(warehouseId)),
        cleanWarehouses: () => dispatch(cleanWarehouses())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseTabs);



// WEBPACK FOOTER //
// ./src/containers/configuration/warehouses/WarehouseTabs.js